import { render, staticRenderFns } from "./RuleGroupManagement.vue?vue&type=template&id=59b1d1cf&"
import script from "./RuleGroupManagement.vue?vue&type=script&lang=js&"
export * from "./RuleGroupManagement.vue?vue&type=script&lang=js&"
import style0 from "./RuleGroupManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports